import { useEffect, useState } from 'react';
import { supabase } from '../lib/webSite';

const BUCKET = 'school-logos';

function publicUrl(filePath) {
  if (!supabase || !filePath) return '';
  const { data } = supabase.storage.from(BUCKET).getPublicUrl(filePath);
  return data?.publicUrl || '';
}

export default function useSchoolLogos() {
  const [logos, setLogos] = useState([]);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      if (!supabase) return;
      try {
        const { data, error } = await supabase
          .from('school_logos')
          .select('id, name, file_path, file_name, sort_order')
          .order('sort_order', { ascending: true })
          .order('created_at', { ascending: true });

        if (error) throw error;
        if (cancelled) return;

        setLogos(
          (data || []).map((row) => ({
            id: row.id,
            name: row.name || row.file_name || 'School logo',
            url: publicUrl(row.file_path),
          })),
        );
      } catch (err) {
        console.warn('Could not load school_logos.', err);
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return logos;
}
